import {Component, Input} from '@angular/core';
import {RelatedProductList} from '../../interface/related-product-list';
import {ActivatedRoute, Params} from '@angular/router';
import {UntilDestroy} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: 'fb-choose-color',
	templateUrl: './choose-color.component.html',
	styleUrls: ['./choose-color.component.scss']
})
export class ChooseColorComponent {
	@Input() dataColor: RelatedProductList[] = [];
	@Input() productId: number = 0;
	public fabricOrFinished: string = '';
	public deltaIndex: number = 0;
	public moreColor: RelatedProductList[] = [];

	constructor(
		private _activatedRoute: ActivatedRoute,
	) {
	}

	public selectFinishOption(i: number): void {
		this.deltaIndex = i;
	}

	public ngOnInit(): void {

		this._activatedRoute.params.subscribe((params: Params): void => {
			this.fabricOrFinished = params['category'];
		});

		this.dataColor.forEach((relatedProduct: RelatedProductList, i: number): void => {

			if (relatedProduct.id == this.productId) this.deltaIndex = i;

			if (i > 4) this.moreColor.push(relatedProduct);
		})

	}
}
